
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiForceGustsRelative as ObiForceGustsRelativeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-force-gusts-relative.js';
 
 
 

 
 export const ObiForceGustsRelative = createComponent({
   react: React,
   tagName: 'obi-force-gusts-relative',
   elementClass: ObiForceGustsRelativeElement,
   events: {
     
   }
  });
 
 